import { proxy, useSnapshot } from 'valtio';
const conversationStateStore = proxy({
    hasClosed: false,
    hasRestarted: false,
});
const setHasClosed = (val) => {
    conversationStateStore.hasClosed = val;
};
const setHasRestarted = (val) => {
    conversationStateStore.hasRestarted = val;
};
export const useConversationClosed = () => {
    const { hasClosed } = useSnapshot(conversationStateStore);
    return { hasClosed, setHasClosed };
};
export const useConversationRestarted = () => {
    const { hasRestarted } = useSnapshot(conversationStateStore);
    return { hasRestarted, setHasRestarted };
};
